<template>
  <div style="width: 100%">
    <vxe-table border auto-resize resizable show-overflow :data="tableData">
      <!-- <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column> -->
      <vxe-table-column type="expand" title="合计" width="60">
        <template #content="{}">
          <ExpandTable :fetchTableData="tableData[0].invoiceInfos" />
        </template>
      </vxe-table-column>
      <vxe-table-column
        v-for="(item, index) of tableColumn"
        :key="index"
        :field="item.field"
        :title="item.title"
        :edit-render="item.itemRender"
        :minWidth="item.width"
      >
      </vxe-table-column>
    </vxe-table>
  </div>
</template>

<script>
  import ExpandTable from './ExpandTable';
  export default {
    name: 'InvoiceInformationExpandTable',
    props: {
      fetchTableData: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        tableColumn: [
          {
            title: '应开票金额',
            field: 'invoiceAmount',
          },

          {
            title: '已开票金额',
            field: 'invoicedAmount',
          },
          {
            title: '未开票金额',
            field: 'unInvoiceAmount',
          },
        ],
        tableData: [],
      };
    },
    components: {
      ExpandTable,
    },
    watch: {
      fetchTableData: {
        handler(val) {
          if (val && Object.keys(val).length) {
            this.tableData = val;
            const unInvoiceAmount = val[0].invoiceAmount - val[0].invoicedAmount;
            this.tableData[0].unInvoiceAmount = unInvoiceAmount ? unInvoiceAmount : null;
          }
        },
        immediate: true,
      },
    },
  };
</script>

<style lang="scss" scoped></style>
